module.exports = __webpack_public_path__ + "static/media/underline.206fd15d.svg";